// Environment configuration for the frontend
interface Environment {
  API_URL: string;
  WS_URL: string;
  ENVIRONMENT: 'development' | 'staging' | 'production';
  FEATURES: {
    ANALYTICS: boolean;
    SENTRY: boolean;
    DEBUG_PANEL: boolean;
  };
  SERVICES: {
    GOOGLE_ANALYTICS_ID: string;
    SENTRY_DSN: string;
  };
}

const environment: Environment = {
  API_URL: import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
  WS_URL: import.meta.env.VITE_WS_URL || 'ws://localhost:8000/ws',
  ENVIRONMENT: (import.meta.env.VITE_ENVIRONMENT as any) || 'development',
  FEATURES: {
    ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    SENTRY: import.meta.env.VITE_ENABLE_SENTRY === 'true',
    DEBUG_PANEL: import.meta.env.NODE_ENV === 'development',
  },
  SERVICES: {
    GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  },
};

export default environment;

// Usage examples:
// if (environment.FEATURES.DEBUG_PANEL) {
//   // Show debug information
// }
//
// if (environment.FEATURES.ANALYTICS) {
//   // Initialize Google Analytics
// }
